import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { StorageKeys } from 'src/app/shared-module-files/simpo.constant';

@Component({
  selector: 'app-session-expired-popup',
  templateUrl: './session-expired-popup.component.html',
  styleUrls: ['./session-expired-popup.component.scss']
})
export class SessionExpiredPopupComponent {

  loading = false;
  networkError = false;

  constructor(
    private dialogRef: MatDialogRef<SessionExpiredPopupComponent>,
    private router: Router,
    private authService: AuthServiceService
  ) {}

  /**
   * User clicks Continue:
   *  - Date.now() < accessTokenExpiresAt - 60s  -> just close and continue
   *  - expired / expires within 60s             -> refresh once, then continue
   *  - refresh 401                              -> logout + redirect to login
   *  - refresh network failure                  -> stay open, allow manual retry
   */
  continue(): void {
    if (this.loading) return;
    this.networkError = false;

    // Token still valid -> just resume, no API call.
    if (!this.authService.isAccessTokenExpiring()) {
      this.dialogRef.close('continue');
      return;
    }

    if (!localStorage.getItem(StorageKeys.REFRESH_TOKEN)) {
      this.logout();
      return;
    }

    // Token expired / expiring -> refresh once.
    this.loading = true;
    this.authService.refreshAccessToken().subscribe({
      next: (res: any) => {
        // Only 401 sends the user to login. Any other successful response
        // means we got fresh tokens -> store them and carry on.
        this.authService.persistAuthSession(res?.data ?? res);
        this.loading = false;
        this.dialogRef.close('continue');
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        if (err?.status === 401) {
          this.logout();
        } else {
          // network / other failure — don't log out, let the user retry
          this.networkError = true;
        }
      },
    });
  }

  logout(): void {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (e) {}
    this.dialogRef.close('logout');
    this.router.navigate(['']).then(() => window.location.reload());
  }
}
